export default {
    title: 'Bài tập của tôi',
    hero: {
        bgAlt: 'Hình nền công viên giải trí',
        panelAlt: 'Bảng tiêu đề Bài tập của tôi',
        title: 'Bài tập của tôi',
        description: 'Hãy kiểm tra bài tập giáo viên giao và hoàn thành từng bước một nhé.',
    },
    aria: {
        boardLabel: 'Bảng bài tập',
        tabsLabel: 'Tab trạng thái bài tập',
        progress: 'Tiến độ bài tập {percent}%',
        actionButton: '{title} {label}',
    },
    tabs: {
        active: 'Đang thực hiện',
        ended: 'Đã kết thúc',
    },
    meta: {
        activityCount: 'Số hoạt động',
        createdAt: 'Ngày tạo',
        endedAt: 'Ngày kết thúc',
    },
    status: {
        before: 'Chưa bắt đầu',
        inprogress: 'Đang thực hiện',
        complete: 'Hoàn thành',
        endedComplete: 'Hoàn thành',
        endedIncomplete: 'Chưa hoàn thành',
    },
    actions: {
        view: 'Xem bài tập',
        studyComplete: 'Đã hoàn thành',
        viewResult: 'Xem kết quả',
    },
    stamp: {
        alt: 'Dấu hoàn thành',
    },
    empty: {
        active: 'Không có bài tập đang thực hiện.',
        ended: 'Không có bài tập đã kết thúc.',
    },
    activity: {
        name: 'Hoạt động {index}',
    },
    modal: {
        closeAria: 'Đóng cửa sổ',
        close: 'Đóng',
        start: 'Bắt đầu',
    },
    flash: {
        title: {
            info: 'Thông báo',
            warning: 'Chú ý',
            error: 'Lỗi',
        },
        confirm: 'Xác nhận',
    },
};
